export default __webpack_public_path__ + "static/media/420.e563928c.jpg";